import React from 'react';
import './index.scss';

type ButtonPrimaryProps = {
  id?: string,
  type: 'button' | 'submit' | 'reset';
  children: React.ReactNode;
  onClick?: () => void;
  size?: 'large' | 'medium' | 'small';
  active?: boolean;
  disabled?: boolean;
  variant?: string;
  className?: string;
};

export const ButtonPrimary = ({
  id,
  type,
  children,
  onClick,
  size = 'large',
  active,
  disabled,
  variant,
  className,
}: ButtonPrimaryProps) => {
  return (
    <button
      id={id}
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`ButtonPrimary ButtonPrimary-${size} ${
        active ? 'ButtonPrimary--active' : ''
      } ${variant ? 'ButtonPrimary--' + variant : ''} ${
        className ?? ''
      }`}
    >
      {children}
    </button>
  );
};
